module.exports = __webpack_public_path__ + "media/images/icons/512-7973fbdd5f32956e381bce850d578a6b.png";